/**
 * Campaign List V2 — wrapper query helpers and row normalization.
 */

import {
  buildSearchRuleItems,
  injectSearchIntoFilters,
  prepareWrapperFilters,
  buildWrapperInsightsQueryBody,
} from "../../helper/insights/insightsFilterUtils";
import { normalizeBidStrategyLabel } from "../../helper/bulkSelection/bulkCampaignUpdate";
import {
  CAMPAIGN_LIST_V2_ALWAYS_MEASURES,
  CAMPAIGN_LIST_V2_DEFAULT_DIMENSIONS,
  CAMPAIGN_LIST_V2_PAGE_MEASURES,
} from "./campaignListV2Configs";

export { prepareWrapperFilters, buildSearchRuleItems };
/**
 * Top search box injection (all under dimensions).
 */
export function injectCampaignListSearchIntoFilters(
  filters,
  searchText,
  dimensionMembers = [
    "campaign_name",
    "portfolio_name",
    "targeting",
    "ad_group_name",
  ]
) {
  return injectSearchIntoFilters(filters, searchText, dimensionMembers);
}

export function buildCampaignInsightsQueryBody({
  queryDimensions = CAMPAIGN_LIST_V2_DEFAULT_DIMENSIONS,
  filters = {},
  queryMeasure = CAMPAIGN_LIST_V2_PAGE_MEASURES,
  queryOrder = [["spends", "desc"]],
  timeDimensions = [],
  offset = 0,
  limit = 50,
}) {
  return buildWrapperInsightsQueryBody({
    queryDimensions,
    filters,
    queryMeasure,
    alwaysMeasures: CAMPAIGN_LIST_V2_ALWAYS_MEASURES,
    queryOrder,
    timeDimensions,
    offset,
    limit,
  });
}

export function normalizeCampaignListInsightRow(row) {
  const campaignStatus = String(row?.campaign_status ?? "").toUpperCase();
  const adgroupStatus = String(row?.adgroup_status ?? "").toUpperCase();
  const targeting = String(row?.targeting ?? row?.targeting_type ?? "").trim();
  const campaignName = String(row?.campaign_name ?? row?.name ?? "").trim();
  const portfolioName = String(row?.portfolio_name ?? "").trim();
  const adGroupName = String(row?.ad_group_name ?? "").trim();

  // Wrapper returns labels like "Down" / "Up & Down" (or legacy API enums).
  const bidLabel = normalizeBidStrategyLabel(
    row?.campaign_bid_strategy ?? row?.bid_strategy ?? ""
  );

  const budgetVal =
    row?.campaign_budget ?? row?.budget ?? row?.daily_budget ?? "";

  return {
    ...row,
    campaign_id: row?.campaign_id != null ? String(row?.campaign_id) : "",
    campaign_name: campaignName,
    campaign_type: row?.campaign_type ?? "",
    ad_group_id: row?.ad_group_id != null ? String(row?.ad_group_id) : "",
    ad_group_name: adGroupName,
    targeting,
    portfolio_name: portfolioName,
    campaign_status: campaignStatus,
    adgroup_status: adgroupStatus,
    campaign_budget: budgetVal,
    budget: budgetVal,
    daily_budget: budgetVal,

    campaign_bid_strategy: bidLabel,
    bid_strategy_api_value: bidLabel,
    bid_strategy_label: bidLabel,

    campaign_burn_rate: row?.campaign_burn_rate ?? null,

    // V2 table state
    isChecked: false,
  };
}

export function normalizeCampaignListInsightRows(rows) {
  return (rows || []).map((r) => normalizeCampaignListInsightRow(r));
}
